<template>
  <footer class="dd-footer">
    <p>广州数鸽科技有限公司 版权所有 <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备15042289号</a></p>
    <p>Copyright &#169; 2019 - 现在 All Rights Reserved</p>
  </footer>
</template>

<script>
export default {
  
}
</script>

<style lang="scss">
.dd-footer {
  padding: 57px 0;
  text-align: center;
  color: #fff;
  font-size: 17px;

  p {
    margin: 1em;
  }
  a {
    color: inherit;
    
    &:hover {
      text-decoration: underline;
    }
  }
  @include media-tablet {
    font-size: 11px;
  }
}
</style>
